export default __webpack_public_path__ + "static/media/cross.inline.57be4186.svg";